import script from "./Proudct.vue?vue&type=script&setup=true&lang=js"
export * from "./Proudct.vue?vue&type=script&setup=true&lang=js"

import "./Proudct.vue?vue&type=style&index=0&id=57645110&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57645110"]])

export default __exports__